<template>
    <CModal
      :title="title"
      :color="color"
      size="lg"
      :show.sync="questionModal"
    >   
        <CForm>
            
            <CRow>
              <CCol md="9">
                <CInput
                  label="Pregunta:"
                  :lazy="false"
                  :value.sync="$v.form.name.$model"
                  :isValid="checkIfValid('name')"
                  placeholder=""
                  autocomplete="given-name"
                  invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres."
                />
              </CCol>
              <CCol md="3">
                <CSelect
                    label="Tipo"
                    id="type"
                    name="type"
                    :value.sync="$v.form.type.$model"
                    :options="typeOptions"
                  />
              </CCol>
            </CRow>
            <CRow>
              <CCol md="9">
                <CInput
                  label="Descripción:"
                  :lazy="false"
                  :value.sync="$v.form.description.$model"
                  placeholder=""
                />
              </CCol>
              <CCol md="3">
                <CSelect
                    label="Requerido"
                    id="required"
                    name="required"
                    :value.sync="$v.form.required.$model"
                    :options="[{label: 'SI', value: '1'}, {label: 'NO', value: '0'}]"
                  />
              </CCol>
            </CRow>
            <CRow>
              <CCol md="4">
                <label class="d-block">Variante de respuesta</label>
                <label v-if="form.type != 'permission'"><input type="checkbox" v-model="form.allow_not_applicable"> Permitir "No aplica"</label>
                <span v-else>Respuestas fijas: SI / NO</span>
              </CCol>
              <CCol md="8" v-if="form.allow_not_applicable">
                <CInput label="Texto del checkbox:" v-model="form.not_applicable_label" placeholder="Ej. No aplica porque soy extranjero" />
              </CCol>
            </CRow>
            <CRow v-show="form.type == 'options'">
              <CCol md="12">
                <CInput
                  label="Opciones (separadas por comas):"
                  :lazy="false"
                  :value.sync="$v.form.options.$model"
                  placeholder=""
                />
              </CCol>
            </CRow>
            <CRow v-if="form.type == 'permission'">
              <CCol md="12">
                <CInput label="Link de autorización" :value.sync="form.permission_link" placeholder="https://..." />
              </CCol>
              <CCol md="12">
                <CInput label="Título clickeable" :value.sync="form.permission_link_title" placeholder="Abrir autorización" />
              </CCol>
              <CCol md="12">
                <CInput label="Texto adicional" :value.sync="form.permission_instructions" placeholder="Instrucciones para llenar la autorización" />
              </CCol>
            </CRow>
            <CRow v-if="form.type != 'content'">
              <CCol md="6">
                <CSelect
                  label="Depende de pregunta previa"
                  :value.sync="form.dependency_question_id"
                  :options="dependencyQuestionOptions"
                />
              </CCol>
              <CCol md="6" v-if="form.dependency_question_id">
                <CInput
                  label="Respuesta para mostrar"
                  :lazy="false"
                  :value.sync="form.dependency_answer"
                  placeholder="Ej. SI"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol md="12">
                <label>Agregar por defecto en:</label>
                <div class="d-flex flex-wrap">
                  <label v-for="travelType in travelTypeOptions" :key="travelType.value" class="mr-4 mb-2">
                    <input type="checkbox" :value="travelType.value" v-model="form.travel_types">
                    {{travelType.label}}
                  </label>
                </div>
              </CCol>
            </CRow>
        </CForm>
        <template #footer>
          <CButton @click="closeModal" color="secondary">Cancelar</CButton>
          <CButton @click="store" :color="color">Aceptar</CButton>
        </template>
    </CModal>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required, minLength, email, sameAs, helpers } from "vuelidate/lib/validators"

export default {
  name: 'QuestionModal',
  props: {
    permissions: Array,
    questions: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      questionModal: false,
      title: "Nueva Pregunta",
      color: "info",
      isEdit: false,
      form: this.getEmptyForm(),
      submitted: false,
      fields: [
        {key: 'name', label: 'Pregunta'},
        {key: 'actions', label: '', class: 'actions' }
      ],
      typeOptions: [{label: "Texto", value: "text"}, {label: "Numérico", value: "number"}, {label: "Opciones", value: "options"}, {label: "Permiso", value: "permission"}, {label: "Fecha", value: "date"}, {label: "Archivo", value: "file"}],
      travelTypeOptions: [
        {label: "Nacional", value: "national"},
        {label: "Estados Unidos", value: "usa"},
        {label: "Canadá", value: "canada"},
        {label: "Internacional", value: "international"}
      ],
      special: 0,
    }
  },
  mounted: async function() {
      
  },
  methods: {
    storeModal () {
      this.questionModal = true;
      this.color = "info";
      this.title = 'Nueva Pregunta Predeterminada';
      this.isEdit = false;
      this.submitted = false;
      this.special = 0;

      this.form = {
          id: 0,
          name: '',
          type: 'text',
          description: '',
          options: '',
          required: '1',
          allow_not_applicable: false,
          not_applicable_label: '',
          special: 0,
          dependency_question_id: '',
          dependency_answer: '',
            permission_link: '',
            permission_link_title: '',
            permission_instructions: '',
          travel_types: ['national', 'usa', 'canada', 'international']
      }
    },
    updateModal (special, item) {
      this.questionModal = true;
      this.color = "warning";
      this.title = 'Editar Pregunta';
      this.isEdit = true;
      this.submitted = false;

      this.special = special;

      this.form = {
          id: item.id,
          name: item.question,
          type: item.type,
          description: item.description,
          options: item.options,
          required: item.is_required+"",
          allow_not_applicable: item.allow_not_applicable == 1,
          not_applicable_label: item.not_applicable_label || '',
          special: item.is_special,
          dependency_question_id: item.dependency_question_id ? (item.dependency_question_id + '') : '',
          dependency_answer: item.dependency_answer || '',
            permission_link: item.permission_link || '',
            permission_link_title: item.permission_link_title || '',
            permission_instructions: item.permission_instructions || '',
          travel_types: item.travel_types || []
      };
    },
    store () {
      this.$v.$touch();

      if(!this.form.dependency_question_id){
        this.form.dependency_answer = ''
      }

      if(this.form.type == 'permission'){
        this.form.options = 'SI,NO'
        this.form.allow_not_applicable = false
        this.form.not_applicable_label = ''
      }
      else{
        this.form.permission_link = ''
        this.form.permission_link_title = ''
        this.form.permission_instructions = ''
      }

      if (this.isValid) {
        this.submitted = true;

        if(this.form.id > 0){
          this.$emit("update", this.form );
        }
        else{
          this.$emit("store", this.form );
        }

        this.closeModal();
      }
    },
    closeModal () {
      this.questionModal = false;

      this.form = this.getEmptyForm()
      this.submitted = false
      this.$v.$reset()
    },
    getEmptyForm () {
      return {
          id: 0,
          name: '',
          type: 'text',
          description: '',
          options: '',
          required: '0',
          allow_not_applicable: false,
          not_applicable_label: '',
          special: 0,
          dependency_question_id: '',
          dependency_answer: '',
            permission_link: '',
            permission_link_title: '',
            permission_instructions: '',
          travel_types: ['national', 'usa', 'canada', 'international']
      }
    },
    checkIfValid (fieldName) {
      const field = this.$v.form[fieldName]
      if (!field.$dirty) {
        return null
      }
      
      return !(field.$invalid || field.$model === '')
    },
  },
  computed: {
    formString () { return JSON.stringify(this.form, null, 4) },
    isValid () {
      return !this.$v.form.$invalid
        && (!this.form.allow_not_applicable || this.form.not_applicable_label.trim().length > 0)
        && (!this.form.dependency_question_id || (this.form.dependency_answer || '').trim().length > 0)
        && (this.form.type != 'permission' || (
          (this.form.permission_link || '').trim().length > 0
          && (this.form.permission_link_title || '').trim().length > 0
          && (this.form.permission_instructions || '').trim().length > 0
        ))
    },
    isDirty () { return this.$v.form.$anyDirty },
    dependencyQuestionOptions () {
      const options = [{ label: 'Ninguna', value: '' }]
      this.questions
        .filter(question => ['options', 'permission'].includes(question.type) && question.id !== this.form.id)
        .forEach(question => {
          options.push({ label: question.question, value: question.id + '' })
        })

      return options
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3)
      },
      type: { },
      description: { },
      options: { },
      required: { },
      allow_not_applicable: { },
      not_applicable_label: { }
    }
  },
}
</script> 